export default __webpack_public_path__ + "static/media/user3.f82db6f4.jpg";